export const getMapsLink = (location?: string | number[]) => {
  if (!location) {
    console.error("Standort konnte nicht ermittelt werden");
    return;
  }
  const query =
    typeof location === "string" ? location : `${location[1]},${location[0]}`;
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
};
